
import Vue, { PropType } from "vue";
import { DialogI, DialogCloseType } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import RepetitionAudioSelectedLessonList from "@/components/repetitionAudio/RepetitionAudioSelectedLessonList.vue";

export default Vue.extend({
  name: "RepetitionAudioSelectLessonDialog",
  components: {
    BaseDialog,
    RepetitionAudioSelectedLessonList,
  },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  methods: {
    close() {
      this.dialog.close({ type: DialogCloseType.CLOSED, payload: {} });
    },
  },
});
